// extracted by mini-css-extract-plugin
module.exports = {"sideBar":"sideBar__o5u8S"};